<div
  #menuRoot
  class="user-menu"
  (click)="stopPropagation($event)"
  >
  <app-environment-badge></app-environment-badge>
  <ion-button
    fill="clear"
    class="avatar-trigger"
    (click)="onTriggerClick($event)"
    title="Open quick actions"
    aria-label="Open quick actions"
    >
    <span class="avatar-badge">{{ initials }}</span>
  </ion-button>

  <ion-popover
    #userPopover
    [isOpen]="isOpen"
    [event]="popoverEvent"
    [showBackdrop]="false"
    side="bottom"
    alignment="end"
    class="user-menu-popover"
    (didDismiss)="onPopoverDidDismiss()"
    >
    <ng-template>
      <div
        class="menu-dropdown"
        (click)="stopPropagation($event)"
        >
        <div class="identity">
          <p class="name">{{ displayName }}</p>
          @if (userEmail) {
            <p class="email">{{ userEmail }}</p>
          }
        </div>

        <div class="menu-theme-switch">
          <app-theme-selector [stretch]="true"></app-theme-selector>
        </div>

        <button type="button" class="dropdown-item" (click)="goToAccount()">
          <ion-icon name="settings-outline"></ion-icon>
          User settings
        </button>
        <button type="button" class="dropdown-item" (click)="goToFeedback()">
          <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
          Send feedback
        </button>
        @if (isOwner) {
          <button type="button" class="dropdown-item" (click)="goToFeedbackInbox()">
            <ion-icon name="file-tray-full-outline"></ion-icon>
            Feedback inbox
          </button>
        }
        <button type="button" class="dropdown-item danger" (click)="logout()">
          <ion-icon name="log-out-outline"></ion-icon>
          Logout
        </button>
      </div>
    </ng-template>
  </ion-popover>
</div>
